import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/referrer/_layout/tenants/_layout/')({
  component: () => null, // La lista la rende il layout.
});
